import './css/styles.scss';

function citatInit() {}

citatInit();
